import React, { useState } from 'react';
import QRCode from 'react-qr-code';
import FacebookIcon from '@mui/icons-material/Facebook';

function GenerateQR({title = null, description = null}) {
  const initialUrl = typeof window !== 'undefined' ? window.location.href : 'https://www.devssoft.com';
  
  const [value, setValue] = useState(initialUrl);

  return (
    <div>
      {title && <h1>{title}</h1>}
      {description && <h3>{description}</h3>}
      
      <br />
      <br />
      
      {value && (
        <QRCode
          value={value}
          size={256}
          bgColor="#FFFFFF"
          fgColor="#000000"
          level="L"
          style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        />
      )}
      
      <p>{value}</p>
      <p><a style={{"display":"flex","alignContent":"center"}} href={"https://www.facebook.com/sharer/sharer.php?u=" + value}><FacebookIcon /></a></p>
    </div>
  );
}

export default GenerateQR;